import StoredContentContainer from '../../containers/StoredContentContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TrackExamPage = ({
  track,
  trackProgress,
  onAdvanceContent
}) => {
  const exam = track.exam;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: exam && /*#__PURE__*/_jsx(StoredContentContainer, {
      content: exam,
      onFinish: onAdvanceContent,
      track: track,
      trackProgress: trackProgress
    })
  });
};
export default TrackExamPage;